<script setup>
const emit = defineEmits(['toggle'])

import { useUserStore } from '@store/user'
import { useMetadataStore } from '@store/metadata'
import { useRoute, useRouter } from 'vue-router'
// Modals moved to TopBar; keep sidebar lightweight
import UserService from '@services/user'
import { ArrowRightBold, Setting, Document } from '@element-plus/icons-vue'
import RequestsApi from '@api/requests.api.js'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import Logo from '../../../assets/svg/logo.svg?component'
import LogoMini from '../../../assets/svg/logoMini.svg?component'
import Collapse from '../../../assets/svg/collapse.svg?component'
import UnCollapse from '../../../assets/svg/unCollapse.svg?component'
import Home from '../../../assets/svg/home.svg?component'
import ProjectsMenu from '../../../assets/svg/projects-menu.svg?component'
import DocumentsMenu from '../../../assets/svg/documents-menu.svg?component'
import RequestsMenu from '../../../assets/svg/requests-menu.svg?component'
import MyActivitiesMenu from '../../../assets/svg/my-activities-menu.svg?component'
import AnalyticsMenu from '../../../assets/svg/analytics-menu.svg?component'
import TamersMenu from '../../../assets/svg/tamers-menu.svg?component'
import ListsMenu from '../../../assets/svg/lists-menu.svg?component'
import SettingsMenu from '../../../assets/svg/settings-menu.svg?component'
import FAQMenu from '../../../assets/svg/faq-menu.svg?component'
import UploadMenu from '../../../assets/svg/upload-menu.svg?component'

const route = useRoute()
const router = useRouter()
const metadataStore = useMetadataStore()
let requestsCount = ref(0)

const login = () => { }

let userId = computed(() => {
    return useUserStore().user.id
})

const businessDomains = computed(() => {
    return metadataStore.metadata.businessDomains || []
})

const offerings = computed(() => {
  const offeringsData = metadataStore.metadata?.offering || [];
  return offeringsData.filter((offering) => offering.has_projects === 1 && offering.id !== 18);
});

function getMyRequests(page = 1) {
    // RequestsApi.getRequests({ teamLead: userId.value })
    //     .then(({ data }) => {
    //         requestsCount.value = data.data.to_requests_pagination.total;
    //     })
    //     .catch((error) => {});
}

const navigateTo = (page) => {
    if (page === 'documents') {
        sessionStorage.setItem('document_status', false)
    }
    if (route.name === page) {
        router.go(0)
    }
}

const navigateToHome = () => {
    router.push({ name: 'home' })
}

const navigateToProject = () => {
    router.push({ name: 'projects' })
}

const navigateToAllProjects = () => {
    //router.push({ name: 'projects' })
    window.location.href = '/projects'
}

const navigateToProjectByOffering = (offering) => {
    router.push({
        name: 'projects',
        query: {
            OrderByCreatedDate: 'true',
            'OfferingId[0]': offering.id,
            //   _t: Date.now(), // Force navigation with timestamp
        },
    })
}

const navigateToDocuments = () => {
    router.push({ name: 'documents' })
}

const navigateToAllDocuments = () => {
    //router.push({ name: 'documents.category', params: { slug: 'all' } })
    window.location.href = '/documents/category/all'
}

const navigateToTamProjects = () => {
    router.push({ name: 'documents.category', params: { slug: 'tam-projects' } })
}

const navigateToDomainOffering = () => {
    router.push({
        name: 'documents.category',
        params: { slug: 'domain-offering' },
    })
}

const navigateToSupportService = () => {
    router.push({
        name: 'documents.category',
        params: { slug: 'support-service' },
    })
}

const navigateToThirdParty = () => {
    router.push({ name: 'documents.category', params: { slug: 'third-party' } })
}

const navigateToOtherDocuments = () => {
    router.push({ name: 'documents.category', params: { slug: 'other' } })
}

const navigateToRequests = (type) => {
    router.push({ name: type + '-requests' })
}

const navigateToMyActivities = () => {
    router.push({ name: 'my.knowledge' })
}

const navigateToAnalytics = () => {
    router.push({ name: 'analytics' })
}

const navigateToTamers = () => {
    router.push({ name: 'tamers' })
}

const navigateToLists = () => {
    router.push({ name: 'lists' })
}

const navigateToSettings = () => {
    router.push({ name: 'settings' })
}

const navigateToFAQ = () => {
    router.push({ name: 'faq' })
}

const navigateToUsers = () => {
    router.push({ name: 'users' })
}

const navigateToRoles = () => {
    router.push({ name: 'roles' })
}

const navigateToClients = () => {
    router.push({ name: 'clients' })
}

const navigateToClientTypes = () => {
    router.push({ name: 'clients-types' })
}

const navigateToServiceLines = () => {
    router.push({ name: 'service-lines' })
}

const navigateToBusinessDomains = () => {
    router.push({ name: 'business-domains' })
}

const navigateToBusinessUnits = () => {
    router.push({ name: 'business-units' })
}

const navigateToOfferings = () => {
    router.push({ name: 'offerings' })
}

const navigateToIndustry = () => {
    router.push({ name: 'industry' })
}

const navigateToDigitalSolutions = () => {
    router.push({ name: 'digital-solutions' })
}

const navigateToManagedServices = () => {
    router.push({ name: 'managed-services' })
}

const navigateToDocumentTypes = () => {
    router.push({ name: 'document-types' })
}

const navigateToShareability = () => {
    router.push({ name: 'sharebility' })
}

const navigateToApprovalsMembers = () => {
    router.push({ name: 'approvals-members' })
}

const navigateToDefaultPartners = () => {
    router.push({ name: 'default-partners' })
}

const logout = async () => {
    useUserStore()
        .logout()
        .then(() => {
            localStorage.clear()
            router.push({ name: 'login' })
        })
        .catch((error) => { })
}

onMounted(async () => {

    // Load metadata if not already loaded
    if (!metadataStore.loaded) {
        await metadataStore.fetchData()
    }
    getMyRequests()

    Echo.channel('items').listen('.count-event', (event) => {
        getMyRequests()
    })

    // Modals moved to TopBar; events handled there now
})

const showMainSettings = ref(false)
const showLists = ref(false)
const showDocuments = ref(false)
const showUploadDropdown = ref(false)

const onDocumentCreated = (doc) => {
    try {
        window.dispatchEvent(new CustomEvent('document-created', { detail: doc }))
    } catch (e) { }
}

const { collapse, handleOpen, handleClose } = defineProps({
    collapse: { type: Boolean, default: false },
    handleOpen: { type: Function, default: () => { } },
    handleClose: { type: Function, default: () => { } },
})

// Local wrappers to avoid Vue instance method resolution warnings
const onMenuOpen = (...args) => {
    try { handleOpen && handleOpen(...args) } catch (e) { }
}
const onMenuClose = (...args) => {
    try { handleClose && handleClose(...args) } catch (e) { }
}

// Dialog state moved to TopBar

// Bridge functions to open dialogs via global events
const openUploadDocumentFromSidebar = () => {
    try {
        globalThis.dispatchEvent(
            new CustomEvent('open-upload-document', { detail: {} })
        )
    } catch (e) {
        try {
            window && window.dispatchEvent(new CustomEvent('open-upload-document', { detail: {} }))
        } catch (_) { }
    }
}

const openCreateProjectFromSidebar = () => {
    try {
        globalThis.dispatchEvent(
            new CustomEvent('open-create-project', { detail: {} })
        )
    } catch (e) {
        try {
            window && window.dispatchEvent(new CustomEvent('open-create-project', { detail: {} }))
        } catch (_) { }
    }
}

const isCollapsed = ref(collapse)
const defaultOpenedMenus = ref(['2']) // Default to open Projects menu
const activeMenuIndex = ref('1') // Default active menu

const handleToggle = () => {
    isCollapsed.value = !isCollapsed.value
    emit('toggle', isCollapsed.value)
}

watch(
    () => collapse,
    (newValue) => {
        isCollapsed.value = newValue
    }
)

// Watch for route changes to open appropriate menu
watch(
    () => route.name,
    (newRouteName) => {
        if (newRouteName === 'projects') {
            defaultOpenedMenus.value = ['2']
            updateProjectsActive()
        } else if (
            newRouteName === 'documents' ||
            newRouteName === 'documents.category'
        ) {
            defaultOpenedMenus.value = ['3']
            if (newRouteName === 'documents') {
                activeMenuIndex.value = '3-1' // All Documents
            } else if (route.params.slug === 'all') {
                activeMenuIndex.value = '3-1' // All Documents
            } else if (route.params.slug === 'tam-projects') {
                activeMenuIndex.value = '3-2' // TAM Projects Documents
            } else if (route.params.slug === 'domain-offering') {
                activeMenuIndex.value = '3-3' // Domain/Offering Documents
            } else if (route.params.slug === 'support-service') {
                activeMenuIndex.value = '3-4' // Support Service Documents
            } else if (route.params.slug === 'third-party') {
                activeMenuIndex.value = '3-5' // Third Party Documents
            } else if (route.params.slug === 'other') {
                activeMenuIndex.value = '3-6' // Other Documents
            } else {
                activeMenuIndex.value = '3-1' // Default to All Documents
            }
        } else if (
            newRouteName === 'projects-requests' ||
            newRouteName === 'documents-requests'
        ) {
            defaultOpenedMenus.value = ['4']
            activeMenuIndex.value =
                newRouteName === 'projects-requests' ? '4-1' : '4-2'
        } else if (newRouteName === 'my.knowledge') {
            defaultOpenedMenus.value = ['5']
            activeMenuIndex.value = '5'
        } else if (newRouteName === 'analytics') {
            defaultOpenedMenus.value = ['6']
            activeMenuIndex.value = '6'
        } else if (newRouteName === 'tamers') {
            defaultOpenedMenus.value = ['7']
            activeMenuIndex.value = '7-1'
        } else if (newRouteName === 'lists') {
            defaultOpenedMenus.value = ['8']
            activeMenuIndex.value = '8-1'
        } else if (
            newRouteName === 'settings' ||
            newRouteName === 'users' ||
            newRouteName === 'roles' ||
            newRouteName === 'clients' ||
            newRouteName === 'clients-types' ||
            newRouteName === 'service-lines' ||
            newRouteName === 'business-domains' ||
            newRouteName === 'business-units' ||
            newRouteName === 'offerings' ||
            newRouteName === 'industry' ||
            newRouteName === 'digital-solutions' ||
            newRouteName === 'managed-services' ||
            newRouteName === 'document-types' ||
            newRouteName === 'sharebility' ||
            newRouteName === 'approvals-members' ||
            newRouteName === 'default-partners'
        ) {
            defaultOpenedMenus.value = ['9']
            if (newRouteName === 'users') activeMenuIndex.value = '9-1'
            else if (newRouteName === 'roles') activeMenuIndex.value = '9-2'
            else if (newRouteName === 'clients') activeMenuIndex.value = '9-3'
            else if (newRouteName === 'clients-types') activeMenuIndex.value = '9-4'
            else if (newRouteName === 'service-lines') activeMenuIndex.value = '9-5'
            else if (newRouteName === 'business-domains')
                activeMenuIndex.value = '9-6'
            else if (newRouteName === 'business-units') activeMenuIndex.value = '9-7'
            else if (newRouteName === 'offerings') activeMenuIndex.value = '9-8'
            else if (newRouteName === 'industry') activeMenuIndex.value = '9-9'
            else if (newRouteName === 'digital-solutions')
                activeMenuIndex.value = '9-10'
            else if (newRouteName === 'managed-services')
                activeMenuIndex.value = '9-11'
            else if (newRouteName === 'document-types') activeMenuIndex.value = '9-12'
            else if (newRouteName === 'sharebility') activeMenuIndex.value = '9-13'
            else if (newRouteName === 'approvals-members')
                activeMenuIndex.value = '9-14'
            else if (newRouteName === 'default-partners')
                activeMenuIndex.value = '9-15'
            else activeMenuIndex.value = '9-1'
        } else if (newRouteName === 'faq') {
            defaultOpenedMenus.value = ['10']
            activeMenuIndex.value = '10'
        } else {
            defaultOpenedMenus.value = []
            activeMenuIndex.value = '1'
        }
    },
    { immediate: true }
)

function updateProjectsActive() {
    const raw = route.query['OfferingId[0]']
    if (raw) {
        const offeringId = parseInt(raw)
        const offeringIndex = offerings.value.findIndex((o) => o.id === offeringId)
        if (offeringIndex !== -1) {
            activeMenuIndex.value = `2-${offeringIndex + 2}`
            return
        }
    }
    activeMenuIndex.value = ''
}

watch(
    [() => offerings.value, () => route.query['OfferingId[0]']],
    () => {
        if (route.name === 'projects') {
            updateProjectsActive()
        }
    }
)

onMounted(() => {
    // Add click listener for mobile sidebar
    //document.addEventListener('click', handleOutsideClick);
})

onUnmounted(() => {
    // Remove click listener and body class
    //document.removeEventListener('click', handleOutsideClick);
    //document.body.classList.remove('sidebar-open');
})
</script>

<template>
    <div
        class="new-side-bar h-100 d-flex flex-column position-fixed"
        style="background-color: var(--main-color); width: inherit"
    >
        <!-- <img
      src="../../../assets/img/back-vector.png"
      alt="side-bar-bg"
      class="side-bar-bg"
    /> -->
        <div class="sidebar--header d-flex justify-content-between align-items-center">
            <div class="sidebar-brand-icon">
                <Logo v-if="!isCollapsed" />
                <LogoMini v-if="isCollapsed" />
            </div>
            <div
                class="toggle-btn"
                @click="handleToggle"
            >
                <Collapse
                    class="nav-link-text"
                    v-if="isCollapsed"
                />
                <UnCollapse
                    class="nav-link-text"
                    v-if="!isCollapsed"
                />
            </div>
        </div>

        <el-menu
            :default-active="activeMenuIndex"
            class="el-menu-vertical-demo"
            :collapse="isCollapsed"
            :default-openeds="defaultOpenedMenus"
            :unique-opened="true"
            @open="onMenuOpen"
            @close="onMenuClose"
        >
            <!-- Home -->
            <el-menu-item
                index="1"
                @click="navigateToHome"
            >
                <Home />
                <span>Home</span>
            </el-menu-item>
            <!-- Projects Dropdown -->
            <el-sub-menu index="2" :class="route.name === 'projects' ? 'is-active' : ''">
                <template #title>
                    <ProjectsMenu @click="navigateToAllProjects" />
                    <span @click="navigateToAllProjects">Projects</span>
                </template>
                <!-- <el-menu-item
                    index="2-1"
                    @click="navigateToAllProjects"
                >
                    All Projects
                </el-menu-item> -->
                <el-menu-item
                    v-for="(offering, index) in offerings"
                    :key="offering.id"
                    :index="`2-${index + 2}`"
                    @click="navigateToProjectByOffering(offering)"
                >
                    <span class="truncate-text-side">{{ offering.name }}</span>
                </el-menu-item>
            </el-sub-menu>
            <!-- Documents Dropdown -->
            <el-sub-menu index="3" :class="route.name === 'documents.category' ? 'is-active' : ''">
                <template #title>
                    <DocumentsMenu  @click="navigateToAllDocuments"  />
                    <span @click="navigateToAllDocuments" >Documents</span>
                </template>
                <!-- <el-menu-item
                    index="3-1"
                    @click="navigateToAllDocuments"
                >
                    All Documents
                </el-menu-item> -->
                <el-menu-item
                    index="3-2"
                    @click="navigateToTamProjects"
                >
                    <span class="truncate-text-side">TAM Projects Documents</span>
                </el-menu-item>
                <el-menu-item
                    index="3-3"
                    @click="navigateToDomainOffering"
                >
                    <span class="truncate-text-side">Domain/Offering Documents</span>
                </el-menu-item>
                <el-menu-item
                    index="3-4"
                    @click="navigateToSupportService"
                >
                    <span class="truncate-text-side">Support Service Documents</span>
                </el-menu-item>
                <el-menu-item
                    index="3-5"
                    @click="navigateToThirdParty"
                >
                    <span class="truncate-text-side">Third Party Documents</span>
                </el-menu-item>
                <el-menu-item
                    index="3-6"
                    @click="navigateToOtherDocuments"
                >
                    <span class="truncate-text-side">Other Documents</span>
                </el-menu-item>
            </el-sub-menu>
            <!-- Requests Dropdown -->
            <el-sub-menu index="4">
                <template #title>
                    <RequestsMenu />
                    <span>Requests</span>
                </template>
                <el-menu-item
                    index="4-1"
                    @click="navigateToRequests('projects')"
                >Projects Requests</el-menu-item>
                <el-menu-item
                    index="4-2"
                    @click="navigateToRequests('documents')"
                >Documents Requests</el-menu-item>
            </el-sub-menu>
            <!-- My Activities -->
            <el-menu-item
                index="5"
                @click="navigateToMyActivities"
            >
                <MyActivitiesMenu />
                <span>My Activities</span>
            </el-menu-item>
            <!-- Analytics -->
            <el-menu-item
                index="6"
                @click="navigateToAnalytics"
            >
                <AnalyticsMenu />
                <span>Analytics</span>
            </el-menu-item>
            <!-- Tamers Dropdown -->
            <el-sub-menu index="7">
                <template #title>
                    <TamersMenu />
                    <span>Tamers</span>
                </template>
                <el-menu-item
                    index="7-1"
                    @click="navigateToTamers"
                >Tamers domain (1)</el-menu-item>
                <el-menu-item
                    index="7-2"
                    @click="navigateToTamers"
                >Tamers domain (2)</el-menu-item>
                <el-menu-item
                    index="7-3"
                    @click="navigateToTamers"
                >Tamers domain (3)</el-menu-item>
            </el-sub-menu>
            <!-- Lists Dropdown -->
            <el-sub-menu index="8">
                <template #title>
                    <ListsMenu />
                    <span>Osharek List</span>
                </template>
                <el-menu-item
                    index="8-1"
                    @click="navigateToLists"
                >Lists domain (1)</el-menu-item>
                <el-menu-item
                    index="8-2"
                    @click="navigateToLists"
                >List domain (2)</el-menu-item>
                <el-menu-item
                    index="8-3"
                    @click="navigateToLists"
                >List domain (3)</el-menu-item>
                <el-sub-menu index="8-4">
                    <template #title><span>item four</span></template>
                    <el-menu-item index="8-4-1">item one</el-menu-item>
                </el-sub-menu>
            </el-sub-menu>
            <!-- Settings Dropdown -->
            <el-sub-menu
                index="9"
                v-if="
                    UserService.hasPermission('read', 'Role') ||
                    UserService.hasPermission('read', 'User') ||
                    UserService.hasPermission('read', 'Client') ||
                    UserService.hasPermission('read', 'ClientType') ||
                    UserService.hasPermission('read', 'ServiceLine') ||
                    UserService.hasPermission('read', 'BusinessDomain') ||
                    UserService.hasPermission('read', 'BusinessUnit') ||
                    UserService.hasPermission('read', 'Offering') ||
                    UserService.hasPermission('read', 'Industry') ||
                    UserService.hasPermission('read', 'DigitalSolution') ||
                    UserService.hasPermission('read', 'ManagedService') ||
                    UserService.hasPermission('read', 'DocumentType') ||
                    UserService.hasPermission('read', 'Shareability')
                "
            >
                <template #title>
                    <SettingsMenu />
                    <span>Settings</span>
                </template>
                <el-menu-item
                    index="9-1"
                    @click="navigateToUsers"
                    v-if="UserService.hasPermission('read', 'User')"
                >
                    Users
                </el-menu-item>
                <el-menu-item
                    index="9-2"
                    @click="navigateToRoles"
                    v-if="UserService.hasPermission('read', 'Role')"
                >
                    Designation
                </el-menu-item>
                <el-menu-item
                    index="9-3"
                    @click="navigateToClients"
                    v-if="UserService.hasPermission('read', 'Client')"
                >
                    Clients
                </el-menu-item>
                <el-menu-item
                    index="9-4"
                    @click="navigateToClientTypes"
                    v-if="UserService.hasPermission('read', 'ClientType')"
                >
                    Client Types
                </el-menu-item>
                <el-menu-item
                    index="9-5"
                    @click="navigateToServiceLines"
                    v-if="UserService.hasPermission('read', 'ServiceLine')"
                >
                    Service Lines
                </el-menu-item>
                <el-menu-item
                    index="9-6"
                    @click="navigateToBusinessDomains"
                    v-if="UserService.hasPermission('read', 'BusinessDomain')"
                >
                    Business Domains
                </el-menu-item>
                <!-- <el-menu-item
                    index="9-7"
                    @click="navigateToBusinessUnits"
                    v-if="UserService.hasPermission('read', 'BusinessUnit')"
                >
                    Business Units
                </el-menu-item> -->
                <el-menu-item
                    index="9-8"
                    @click="navigateToOfferings"
                    v-if="UserService.hasPermission('read', 'Offering')"
                >
                    Offerings
                </el-menu-item>
                <el-menu-item
                    index="9-9"
                    @click="navigateToIndustry"
                    v-if="UserService.hasPermission('read', 'Industry')"
                >
                    Industry
                </el-menu-item>
                <el-menu-item
                    index="9-10"
                    @click="navigateToDigitalSolutions"
                    v-if="UserService.hasPermission('read', 'DigitalSolution')"
                >
                    Digital Solution
                </el-menu-item>
                <el-menu-item
                    index="9-11"
                    @click="navigateToManagedServices"
                    v-if="UserService.hasPermission('read', 'ManagedService')"
                >
                    Managed Services
                </el-menu-item>
                <el-menu-item
                    index="9-12"
                    @click="navigateToDocumentTypes"
                    v-if="UserService.hasPermission('read', 'DocumentType')"
                >
                    Document Types
                </el-menu-item>
                <el-menu-item
                    index="9-13"
                    @click="navigateToShareability"
                    v-if="UserService.hasPermission('read', 'Shareability')"
                >
                    Sharebility
                </el-menu-item>
                <el-menu-item
                    index="9-14"
                    @click="navigateToApprovalsMembers"
                    v-if="
                        UserService.hasPermission('manage-project-approvals', 'Setting')
                    "
                >
                    Approvals Members
                </el-menu-item>
                <el-menu-item
                    index="9-15"
                    @click="navigateToDefaultPartners"
                    v-if="UserService.hasPermission('read', 'DefaultPartner')"
                >
                    Default Partners
                </el-menu-item>
            </el-sub-menu>
            <!-- FAQ -->
            <el-menu-item
                index="10"
                @click="navigateToFAQ"
            >
                <FAQMenu />
                <span>FAQ</span>
            </el-menu-item>
            <div class="sidebar-footer w-100 m-0 p-0">
                <div class="btn-group dropup uploadBtn mainDropdown">
                    <el-popover
                        class="box-item"
                        placement="top-start"
                        trigger="click"
                        popper-class="new-add-popover"
                    >
                        <template #reference>
                            <span
                                aria-expanded="false"
                                class="btn btn-secondary dropdown-toggle upload--btn"
                                data-bs-toggle="dropdown"
                                type="span"
                            >
                                <UploadMenu />
                                <span class="upload--text">Upload New</span>
                            </span>
                        </template>
                        <div class="d-flex flex-column gap-2">
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="openUploadDocumentFromSidebar()"
                            >
                                Upload Documents
                            </a>
                            <a
                                class="dropdown-item"
                                href="#"
                                @click.prevent="openCreateProjectFromSidebar()"
                            >
                                Create New Project
                            </a>
                        </div>

                    </el-popover>

                    <!-- <ul class="dropdown-menu">
            <li>
              <a class="dropdown-item" href="#" @click.prevent="openUploadDocumentFromSidebar()">
                Upload Documents
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="#" @click.prevent="openCreateProjectFromSidebar()">
                Create New Project
              </a>
            </li>
          </ul> -->
                </div>
            </div>
        </el-menu>
    </div>
    <!-- Element Plus dialogs to match View.vue behavior -->
    <!-- Modals moved to TopBar -->
</template>

<style scoped>
.new-side-bar {
    min-height: 100vh;
    transition: all 0.3s ease;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1030;
    /* scrollbar-color: #FDB236 transparent;  */
}

::-webkit-scrollbar-thumb {
    background-color: #fdb236;
    border: 1px solid #f0f0f0;
}

::-webkit-scrollbar-thumb:horizontal {
    border-radius: 10px 10px 0 0;
    max-height: 2px;
}

::-webkit-scrollbar-thumb:vertical {
    border-radius: 10px 0 0 10px;
}

/* .sidebar-brand-icon {
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
} */

.toggle-btn {
    padding: 0.75rem;
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.el-menu-vertical-demo {
    flex: 1;
    width: 100%;
    border-right: none;
}

:deep(.el-menu) {
    border-right: none;
    background-color: transparent !important;
}

:deep(.el-menu-item),
:deep(.el-sub-menu__title) {
    color: rgba(255, 255, 255, 0.8) !important;
    overflow: hidden;

}

:deep(.el-menu-item:hover),
:deep(.el-sub-menu__title:hover) {
    color: white !important;
    background-color: rgba(255, 255, 255, 0.1) !important;
}

:deep(.el-menu-item.is-active) {
    color: white !important;
    background-color: rgba(255, 255, 255, 0.2) !important;
}
</style>
